import { useNavigate } from 'react-router-dom'

import { destroy } from '../../services'
import { Destroy } from 'components/Buttons/Destroy'

export function DestroyButton({ id }: { id: number }) {
  const navigate = useNavigate()

  return (
    <Destroy
      id={id}
      destroy={destroy}
      successMessage="Pedido excluído com sucesso"
      onDestroy={() => navigate('/orders')}
    />
  )
}
